<template>
  <v-autocomplete
    v-model="model"
    :error="error"
    :error-messages="errors"
    :loading="!isLoaded"
    :items="listItems"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :required="required"
    :return-object="returnObject"
  ></v-autocomplete>
</template>

<script>
export default {
  props: ['value', 'error', 'errors', 'itemText', 'itemValue', 'field', 'data', 'items', 'label', 'required', 'returnObject', 'apiEndpoint'],

  data() {
    return {
      search: null,
      isLoaded: true,
      localItems: []
    };
  },

  watch: {
    search(val) {
      // Skip ajax call if search term allready in list
      if (this.data && this.data[this.keyValueObject] && this.data[this.keyValueObject][this.itemText] === val) return;

      // Skip ajax call if selection has been made
      if (this.listItems.some(item => item[this.itemText] === val)) return;

      this.loadItems();
    }
  },

  computed: {
    keyValueObject() {
      return this.field ? this.field.value.replace('_id', '') : null;
    },

    listItems() {
      return this.items ? this.items : this.localItems;
    },

    endpoint() {
      return this.field ? this.field.apiEndpoint : this.apiEndpoint;
    },

    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }
    }
  },

  created() {
    // Clear cached object
    this.$store.commit(`${this.endpoint}/${this.endpoint.toUpperCase()}`, []);

    // Check if you are in edit mode and we have the object cached
    if (this.data && this.data.id && this.data[this.keyValueObject]) {
      this.localItems = [this.data[this.keyValueObject]];
    }
  },

  methods: {
    loadItems() {
      if (!this.search) return;
      this.isLoaded = false;
      this.$store.dispatch(`${this.endpoint}/LOAD`, {filter: { rowsPerPage: 25, search: this.search }})
        .then((result) => {
          this.localItems = result.data;
          this.isLoaded = true;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AutocompleteSelector.vue